import { PDFDocument } from "pdf-lib";

export function ehArquivoPdf(arquivo) {
    return arquivo?.type === "application/pdf" || arquivo?.name?.split(".").pop()?.toLowerCase() === "pdf";
}

/**
 * Junta vários PDFs num só, na ordem recebida (todas as páginas de cada um). Lança um Error com o
 * nome do arquivo problemático se algum não puder ser lido — por exemplo, protegido por senha, que
 * o pdf-lib não consegue abrir.
 */
export async function mesclarPdfs(arquivos, nomeSaida) {
    const destino = await PDFDocument.create();

    for (const arquivo of arquivos) {
        let origem;
        try {
            origem = await PDFDocument.load(await arquivo.arrayBuffer());
        } catch {
            throw new Error(`Não foi possível ler "${arquivo.name}" (PDF protegido por senha ou danificado).`);
        }
        const paginas = await destino.copyPages(origem, origem.getPageIndices());
        paginas.forEach(pagina => destino.addPage(pagina));
    }

    const bytes = await destino.save();
    return new File([bytes], nomeSaida, { type: "application/pdf" });
}
